/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BimCheckDashboardResponse } from '../model/bimCheckDashboardResponse';
import { HoaiDashboardData } from '../model/hoaiDashboardData';
import { QualityDashboardData } from '../model/qualityDashboardData';
import { TasksDashboardResponse } from '../model/tasksDashboardResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DashboardControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDashboardBimCheck(id: number, observe?: 'body', reportProgress?: boolean): Observable<BimCheckDashboardResponse>;
    public getDashboardBimCheck(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BimCheckDashboardResponse>>;
    public getDashboardBimCheck(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BimCheckDashboardResponse>>;
    public getDashboardBimCheck(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDashboardBimCheck.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BimCheckDashboardResponse>('get',`${this.basePath}/dashboard/${encodeURIComponent(String(id))}/bim-check`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDashboardHoaiCheck(id: number, observe?: 'body', reportProgress?: boolean): Observable<Array<HoaiDashboardData>>;
    public getDashboardHoaiCheck(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<HoaiDashboardData>>>;
    public getDashboardHoaiCheck(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<HoaiDashboardData>>>;
    public getDashboardHoaiCheck(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDashboardHoaiCheck.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<HoaiDashboardData>>('get',`${this.basePath}/dashboard/${encodeURIComponent(String(id))}/hoai-check`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDashboardQualityCheck(id: number, observe?: 'body', reportProgress?: boolean): Observable<Array<QualityDashboardData>>;
    public getDashboardQualityCheck(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<QualityDashboardData>>>;
    public getDashboardQualityCheck(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<QualityDashboardData>>>;
    public getDashboardQualityCheck(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDashboardQualityCheck.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<QualityDashboardData>>('get',`${this.basePath}/dashboard/${encodeURIComponent(String(id))}/quality-check`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDashboardTasks(id: number, observe?: 'body', reportProgress?: boolean): Observable<TasksDashboardResponse>;
    public getDashboardTasks(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TasksDashboardResponse>>;
    public getDashboardTasks(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TasksDashboardResponse>>;
    public getDashboardTasks(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDashboardTasks.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TasksDashboardResponse>('get',`${this.basePath}/dashboard/${encodeURIComponent(String(id))}/dashboard-tasks`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
